import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <nav className="bg-cream sticky top-0 z-50 shadow-sm" data-id="element-101">
      <div className="container mx-auto px-4 py-4" data-id="element-102">
        <div className="flex justify-between items-center" data-id="element-103">
          <Link to="/" className="flex items-center" data-id="element-104">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/utRq69J5hAxbiGeb3Ckvjp/logo_jemi.png" alt="Jemi Baby Care Logo" className="h-14 w-auto" data-id="element-105" />
          </Link>
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8" data-id="element-106">
            <Link to="/" className="text-brown hover:text-brown-dark font-medium" data-id="element-107">
              Home
            </Link>
            <Link to="/shop" className="text-brown hover:text-brown-dark font-medium" data-id="element-108">
              Shop
            </Link>
            <Link to="/offerings" className="text-brown hover:text-brown-dark font-medium" data-id="element-109">
              Offerings
            </Link>
            <Link to="/about" className="text-brown hover:text-brown-dark font-medium" data-id="element-110">
              About
            </Link>
            <Link to="/blog" className="text-brown hover:text-brown-dark font-medium" data-id="element-111">
              Education Hub
            </Link>
            <Link to="/community" className="text-brown hover:text-brown-dark font-medium" data-id="element-112">
              Community
            </Link>
            <Link to="/faq" className="text-brown hover:text-brown-dark font-medium" data-id="element-113">
              FAQ
            </Link>
            <Link to="/contact" className="text-brown hover:text-brown-dark font-medium" data-id="element-114">
              Contact
            </Link>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-115">
            <button onClick={toggleMenu} className="text-brown hover:text-brown-dark focus:outline-none" data-id="element-116">
              {isMenuOpen ? <X size={24} data-id="element-117" /> : <Menu size={24} data-id="element-118" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden mt-4 pb-4" data-id="element-119">
            <div className="flex flex-col space-y-4" data-id="element-120">
              <Link to="/" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-121">
                Home
              </Link>
              <Link to="/shop" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-122">
                Shop
              </Link>
              <Link to="/offerings" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-123">
                Offerings
              </Link>
              <Link to="/about" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-124">
                About
              </Link>
              <Link to="/blog" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-125">
                Education Hub
              </Link>
              <Link to="/community" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-126">
                Community
              </Link>
              <Link to="/faq" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-127">
                FAQ
              </Link>
              <Link to="/contact" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-128">
                Contact
              </Link>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navbar;